import paymentRequestService from "@services/master-data/paymentRequestService"
import { action, makeAutoObservable, observable } from "mobx"

class PaymentRequestStore {
  @observable isLoading!: boolean
  @observable listDataIncome!: any
  @observable listDataExpenses!: any

  constructor() {
    makeAutoObservable(this)
    this.listDataIncome = []
    this.listDataExpenses = []
  }

  @action
  async createOrUpdate(body: any) {
    await paymentRequestService.createOrUpdate(body)
  }
  @action
  async activate(id: number, isActive) {
    await paymentRequestService.activate(id, isActive)
  }
  @action
  async getListIncome(params: any) {
    this.isLoading = true
    const result = await paymentRequestService
      .getList(params)
      .finally(() => (this.isLoading = false))
    this.listDataIncome = result
  }

  // Expenses

  @action
  async getListExpenses(params: any) {
    this.isLoading = true
    const result = await paymentRequestService
      .getList(params)
      .finally(() => (this.isLoading = false))
    this.listDataExpenses = result
  }
}

export default PaymentRequestStore
